module.exports = __webpack_public_path__ + "img/wage_example_en.0a6e4f45.jpg";